import { render, staticRenderFns } from "./NewEnquiry.vue?vue&type=template&id=27daffc5&"
import script from "./NewEnquiry.vue?vue&type=script&lang=js&"
export * from "./NewEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27daffc5')) {
      api.createRecord('27daffc5', component.options)
    } else {
      api.reload('27daffc5', component.options)
    }
    module.hot.accept("./NewEnquiry.vue?vue&type=template&id=27daffc5&", function () {
      api.rerender('27daffc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/NewEnquiry.vue"
export default component.exports